import { LinearProgress } from "@mui/material";
import React from "react";

interface ICustomLinearProgressBar{
    totalSteps: 3 | 4;
    currentStep: number;
}

const CustomLinearProgressBar = ({ totalSteps, currentStep } : ICustomLinearProgressBar) => {
  return (
    <div className="flex items-center gap-2 w-full">
      {[...Array(totalSteps)].map((_, index) => (
        <LinearProgress
          key={index}
          className={`${totalSteps === 3 ? "w-1/3" : "w-1/4"} !bg-taupe-50 !h-1 !rounded-lg`}
          variant="determinate"
          value={(index < (currentStep)) ? 100 : (index === currentStep)? 50: 0}
        />
      ))}
    </div>
  );
};

export default CustomLinearProgressBar;
